//@ts-nocheck
import { ReactNode, useEffect, useMemo, useState, Fragment, useCallback } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { createBase } from '../features/base/baseSlice';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { RootState } from '../app/store';
import { toast } from 'sonner';
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import CustomMenuDropdown from './common/CustomMenuDropdown';
import { ChevronDownIcon, CustomUserIcon, LogoutIcon, ProfileSettingIcon } from './icons';
import { logoutUser } from '../features/auth/authSlice';
import { createJob } from '../features/job/jobSlices';
import { fetchDepartmentList } from '../features/department/departmentSlice';
import { fetchLocationList } from '../features/location/locationSlice';
import { EducationTypeOption } from './job/jobType';



interface UserDetails {
  email: ReactNode;
  id: number;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const people = [
  { id: 1, department_name: 'Select a channel', color: 'text-[#4b5563]', department_image: '' },
];

const experienceTypeOptions: EducationTypeOption[] = [
  { id: 1, name: 'Intern' },
  { id: 2, name: 'Entry Level (0 - 2  years)' },
  { id: 3, name: 'Mid (3 - 7 years)' },
  { id: 4, name: 'Senior (8 - 12 years)' },
  { id: 5, name: "Executive (15+ years)" }
];


interface DashboardLayoutProps {
  userDetails: UserDetails; // Update to UserDetails type
}

const CreateNewJob: React.FC<DashboardLayoutProps> = () => {
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState('')
  const dispatch = useAppDispatch();
  const [updateBaseLogo, setUpdateBaseLogo] = useState(null)
  const [updateChannelName, setUpdateChannelName] = useState("")
  const [updateProfileImage, setUpdateProfileImage] = useState("")
  const { createStatus, createError } = useAppSelector((state: RootState) => state.base);
  const [selected, setSelected] = useState(people[0])
  const [teams, setTeams] = useState<any>(null);
  const { baseId } = useParams<{ baseId: string }>();
  const [userDetails, setUserDetails] = useState<any>(null);
  const bases = useAppSelector((state: RootState) => state?.base?.data?.data?.bases);
  const [documentName, setDocumentName] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const [location, setLocation] = useState(null)
  const [locationName, setLocationName] = useState<any>(null);
  const [userId, setUserId] = useState<any>(null);

  // teams 
  useEffect(() => {
    let isMounted = true;
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem('baseDepartmentData');
        if (storedBase) {
          if (isMounted) setTeams(JSON.parse(storedBase));
        } else {
          try {
            const baseResponse = await dispatch(fetchDepartmentList(userDetails?.id || baseId));
            if (isMounted) setTeams(baseResponse.payload);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }

    return () => {
      isMounted = false;
    };
  }, [baseId, dispatch, userDetails?.id]);


  // useEffect(() => {
  //   if (baseId) {
  //     const fetchTeams = async () => {
  //       const storedBaseMember = localStorage.getItem('baseLocationData');
  //       if (storedBaseMember) {
  //         setLocationName(JSON.parse(storedBaseMember));
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(fetchLocationList(baseId));
  //           setLocationName(baseResponse.payload);
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchTeams();
  //   }
  // }, [baseId, dispatch]);



  useEffect(() => {
    if (bases && bases.length > 0) {
      const matchedBase = bases.find((base: { id: number }) => base.id.toString() === baseId);
      if (matchedBase) {
        setUserDetails(matchedBase);
      }
    }
    else if (baseId) {
      setUserDetails(baseId);
    }
    else {
      setUserDetails(null);
    }
  }, [baseId, bases]);



  // Handle document creation
  const handleCreateDocument = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!baseId) {
      console.error('Base ID is required');
      return;
    }
    if (!documentName) {
      toast.error('job title name is required');
      return;
    }
    // Check if department is the default placeholder
    if (selected.id === 1 && selected.department_name === 'Select a channel') {
      toast.error('Department is required');
      return;
    }
    if (!location) {
      toast.error('location is required');
      return;
    }
    setLoading(true);

    try {
      const parsedBaseId = parseInt(baseId, 10);
      if (isNaN(parsedBaseId)) {
        throw new Error('Invalid base ID');
      }

      const resultAction = await dispatch(createJob({
        job_title: documentName,
        job_department_id: selected.id,
        baseId: parsedBaseId,
        experience_level: location.name
      }));


      if (createJob.fulfilled.match(resultAction)) {
        toast.success('Job created successfully!');
        setDocumentName('');
        setSelected(people[0]);
        setLocation(experienceTypeOptions[0]);

        const documentId = (resultAction.payload.data.data.id)
        localStorage.removeItem('jobActionData')
        localStorage.removeItem('jobByReviewData')
        localStorage.removeItem('jobPipelineStageData')
        localStorage.removeItem('jobPostDetailsData')
        localStorage.removeItem('jobByHiringTeamMembers')
        localStorage.removeItem('activeFiltersJobApplication')
        localStorage.removeItem('activeFiltersJobApplicationKanban')
        localStorage.removeItem('activeFiltersJobReports')
        localStorage.removeItem('cachedJobsDetailsListData')
        localStorage.removeItem('baseScoreCardDataByJob')
        localStorage.removeItem('baseQuestionnaireDataByJob')

        localStorage.removeItem("baseJobListingData")
        localStorage.removeItem("activeFiltersTopics");
        localStorage.removeItem('cachedJobsListData')
        localStorage.removeItem('baseJobScoreCardData')
        localStorage.removeItem('baseScoreCardDataByJob')
        localStorage.removeItem('baseQuestionnaireDataByJob')
        localStorage.removeItem('jobPipelineStageData')
        localStorage.removeItem('activeFiltersJobApplication')
        localStorage.removeItem('activeFiltersJobsListing')
        localStorage.removeItem('activeFiltersJobsDetailsPage')
        localStorage.removeItem('activeFiltersJobApplicationKanban')
        localStorage.removeItem('jobByHiringTeamMembers')
        localStorage.removeItem('jobActionData')
        localStorage.removeItem('jobByReviewData')
        localStorage.removeItem('jobPostDetailsData')
        localStorage.removeItem('JobPipelineDetailsData')
        localStorage.removeItem('activeFiltersBookmark')
        localStorage.removeItem('cachedBookmarkData')
        localStorage.removeItem('forgot_email')
        navigate(`/${baseId}/job/${documentId}/manage/detail`);


      } else {
        throw new Error(resultAction.error?.message || 'Failed to create job');
      }
    } catch (err) {
      toast.error('Failed to create job.');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectedChange = useCallback((newValue: any) => {
    if (selected.id !== newValue.id) {
      setSelected(newValue);
    }
  }, [selected.id]);

  const handleLocationChange = useCallback((newValue: any) => {
    if (location?.id !== newValue.id) {
      setLocation(newValue);
    }
  }, [location?.id]);


  const teamOptions = useMemo(() => {
    return teams?.data || [];
  }, [teams?.data]);



  // fetch user image 
  const imageUrl = updateProfileImage
    && `${process.env.REACT_APP_API_BASE_URL}/${updateProfileImage}`



  // fetch base logo
  useEffect(() => {
    const storedData = localStorage.getItem("baseDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);

        if (parsedData && parsedData.data.base && parsedData.data.base.logo) {
          setUpdateBaseLogo(parsedData && parsedData.data.base && parsedData.data.base.logo);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, [updateBaseLogo]);



  // fetch base name 
  useEffect(() => {
    const storedData = localStorage.getItem("baseDetails");
    const finalData = storedData

    if (finalData) {
      try {
        const parsedData = typeof finalData === 'string' ? JSON.parse(finalData) : finalData;

        if (parsedData?.data?.base?.name) {
          setUpdateChannelName(parsedData?.data?.base?.name);
        } else if (finalData?.name) {
          setUpdateChannelName(parsedData?.name);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, []);


  // fetch base logo
  useEffect(() => {
    const storedData = localStorage.getItem("userDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (parsedData && parsedData.profile_pic) {
          setUpdateProfileImage(parsedData && parsedData.profile_pic);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, [updateBaseLogo]);



  const handleSignOut = () => {
    const clearAllStorageData = () => {
      // Clear all localStorage
      localStorage.clear();

      // Specifically remove items related to authentication and persistence
      const keysToRemove = [
        "accessToken",
        "authToken",
        "persist:root",
        "_persist"
      ];

      keysToRemove.forEach(key => localStorage.removeItem(key));
    };

    dispatch(logoutUser())
      .then((resultAction) => {
        if (logoutUser.fulfilled.match(resultAction)) {
          clearAllStorageData();
          toast.success('Successfully logged out!');

          // Use a slight delay to ensure storage clearing is complete
          setTimeout(() => {
            navigate('/login');
          }, 100);
        } else if (logoutUser.rejected.match(resultAction)) {
          const payload = resultAction.payload as { status?: number; message: string };
          if (payload.status === 401) {
            clearAllStorageData();
            toast.error('Session expired. Please log in again.');

            setTimeout(() => {
              window.location.href = '/login';
            }, 100);
          } else {
            toast.error('Logout failed. Please try again.');
          }
        }
      })
      .catch((error) => {
        console.error('Logout action failed', error);
        toast.error('Logout action failed. Please try again.');
      });
  };

  useEffect(() => {
    const storedUserDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
    setUserId(storedUserDetails);
  }, []);

  const handleProfileSetting = () => {
    navigate(`/user/${userId?.id}/profile`)
  }

  // custom dropdown 
  const profileMenuSections = [
    {
      options: [
        { icon: CustomUserIcon, label: userId?.name, onClick: () => console.log('Profile clicked') },
        { icon: ProfileSettingIcon, label: 'Profile Setting', onClick: handleProfileSetting },
      ],
    },
    {
      options: [
        { icon: LogoutIcon, label: 'Sign out', onClick: handleSignOut }
      ],
    },
  ];




  return (
    <div className='h-[calc(100vh_-_0rem)]'>

      <div className='relative isolate flex min-h-svh w-[calc(100%_-_2px)] flex-col bg-white lg:bg-zinc-100 overflow-auto h-full'>
        <header className="flex items-center px-4 h-[56px]">
          <div className="min-w-0 flex-1 h-full">
            <nav className="flex flex-1 items-center gap-4 py-2.5">


              <div className="flex shrink-0 items-center px-[0rem] justify-between w-full">
                <Link to='/base' className=''>
                  <div className='flex gap-[0.5rem] items-center cursor-pointer h-[32px] px-[0rem] w-full'>
                    <img
                      className="h-6 w-6 rounded-[5px]"
                      src={`${process.env.REACT_APP_API_BASE_URL}/public/assets/teamer-logo.png`}
                      alt="base logo"
                    />


                    <span className='leading-[1.2] font-semibold whitespace-nowrap text-[0.8125rem] cursor-pointer truncate w-full max-w-[160px] min-w-[140px] overflow-hidden text-ellipsis
                    text-start  '>{'teamer'}</span>

                    <div className='mx-[6px] w-[1px] h-6 bg-zinc-950/10  block'></div>
                  </div>
                </Link>



                <div className="flex items-center gap-x-4 lg:gap-x-6 w-[350px] relative z-50 [&>button]:hover:bg-transparent justify-end">
                  {/* Profile dropdown */}

                  {/* <div className="flex items-center justify-center">
                    <button
                      onClick={() => navigate('/createbase')}
                      className="rounded-md bg-transparent items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-[text-[#25252d] hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      type="submit"
                    >
                      <span className="px-1">Create New Base</span>
                    </button>
                  </div> */}
                  <CustomMenuDropdown
                    imageUrl={imageUrl}
                    altText="User profile"
                    sections={profileMenuSections}
                    menuItemsClassName="left-auto"
                  />
                </div>

              </div>

            </nav>
          </div>
        </header>

        <main className='flex flex-1 flex-col pb-2 lg:px-2'>
          <div className='grow p-6 rounded-lg bg-white lg:p-0 ring-1 lg:ring-zinc-950/5 shadow-xs '>
            <div className="w-full flex items-center flex-wrap lg:flex-nowrap h-full overflow-auto lg:max-h-[850px]">
              <div className="w-full lg:w-[50%] h-full">
                <div className="flex min-h-full items-center flex-1 flex-col justify-center max-w-[487px] m-auto px-4 py-5">
                  <h2 className='text-[20px] font-semibold text-[#25252d] text-left w-full' >Create New Job</h2>
                  <form className='w-full' action="#" onSubmit={handleCreateDocument}>
                    <div className="mt-4 w-full">

                      <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6 mt-1.5'>Job title</label>
                      <input
                        type="text"
                        name="documentName"
                        placeholder="Enter job name"
                        className="w-full px-3 py-2 border mt-1.5 border-gray-200 !placeholder:[#4b5563] 
                        rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 
                        focus:border-transparent  text-sm text-gray-900 input-job-placeholder"
                        value={documentName} // Bind input value to documentName state
                        onChange={(e) => setDocumentName(e.target.value)} // Update state on input change
                      />
                    </div>

                    <div className='mt-4'>
                      <Listbox value={selected} onChange={handleSelectedChange} by="id">
                        <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6'>Department</label>
                        <div className="relative mt-1.5">
                          <ListboxButton className="relative w-full cursor-default border border-gray-200 rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-white-900 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                            <span className="flex items-center">
                              {/* Use selected.name to display the selected team's name */}
                              {selected ? (
                                <div className='flex items-center gap-x-2 '>
                                  {
                                    selected.department_image ? (
                                      <img
                                        src={`${process.env.REACT_APP_API_BASE_URL}/${selected.department_image}`}
                                        alt={`${selected.department_name || 'Profile'}`}
                                        className="h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10"
                                      />
                                    ) : (
                                      <span
                                        className="bg-[#a3a3a3] flex items-center justify-center h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10
                                                                    text-white text-[14px] font-medium capitalize line-clamp-1"
                                      >
                                        {selected.department_name?.charAt(0).toUpperCase()}
                                      </span>
                                    )
                                  }
                                  <span className={`block truncate ${selected.color}`}>
                                    {selected.department_name}
                                  </span>
                                </div>
                              ) : (
                                "Select a team" // Placeholder if no team is selected
                              )}
                            </span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                              <ChevronDownIcon />
                            </span>
                          </ListboxButton>


                          <ListboxOptions
                            className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full max-h-[200px] overflow-auto
                            rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                            data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                             data-[side=top]:slide-in-from-bottom-2"
                          >
                            {teamOptions.map((person: any) => (
                              <ListboxOption
                                key={person.id}
                                value={person}
                                className={({ active }) =>
                                  classNames(
                                    active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                    'relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer'
                                  )
                                }
                              >
                                <span className="flex items-center gap-x-3">
                                  {
                                    person.department_image ? (
                                      <img
                                        src={`${process.env.REACT_APP_API_BASE_URL}/${person.department_image}`}
                                        alt={`${person.department_name || 'Profile'}`}
                                        className="h-6 w-6 flex-none rounded-full ring-1 ring-gray-900/10"
                                      />
                                    ) : (
                                      <span
                                        className="bg-[#a3a3a3] flex items-center justify-center h-6 w-6 flex-none rounded-full ring-1 ring-gray-900/10
                                                      text-white text-[14px] font-medium capitalize line-clamp-1"
                                      >
                                        {person.department_name?.charAt(0).toUpperCase()}
                                      </span>
                                    )
                                  }

                                  <span className={`block truncate capitalize text-[14px]`}>
                                    {person.department_name}
                                  </span>
                                </span>
                              </ListboxOption>

                            ))}
                          </ListboxOptions>
                        </div>
                      </Listbox>
                    </div>

                    <div className='mt-4'>
                      <Listbox value={location} onChange={handleLocationChange} by="id">
                        <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6'>Experience Type</label>
                        <div className="relative mt-1.5">
                          <ListboxButton className="relative w-full cursor-default border border-gray-200 rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-white-900 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                            <span className="flex items-center text-[#4b5563]">
                              {/* Use selected.name to display the selected team's name */}
                              {location ? (
                                <div className='flex items-center gap-x-2 text-[#4b5563]'>
                                  {location.name}
                                </div>
                              ) : (
                                "Select a experience" // Placeholder if no team is selected
                              )}
                            </span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                              <ChevronDownIcon />
                            </span>
                          </ListboxButton>


                          <ListboxOptions
                            className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full max-h-[200px] overflow-auto
                            rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                            data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                             data-[side=top]:slide-in-from-bottom-2"
                          >
                            {experienceTypeOptions.map((person: any) => (
                              <ListboxOption
                                key={person.id}
                                value={person}
                                className={({ active }) =>
                                  classNames(
                                    active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                    'relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer'
                                  )
                                }
                              >
                                <span className="flex items-center gap-x-3">

                                  <span className={`block truncate capitalize text-[14px]`}>
                                    {person.name}
                                  </span>
                                </span>
                              </ListboxOption>

                            ))}
                          </ListboxOptions>
                        </div>
                      </Listbox>
                    </div>

                    <div className="flex items-center justify-end gap-[22px] pt-10 flex-wrap md:flex-nowrap lg:flex-nowrap">
                      <button
                        type="submit"
                        className='group inline-flex shrink-0 w-fit select-none justify-center items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 transition-colors
                             duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 
                           rounded-md text-white outline-indigo-600
                             disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'
                      >
                        {loading ? (
                          <div className='flex items-center  gap-[6px]'>
                            Create
                            <div className="simple-spinner">
                              <span></span>
                            </div>
                          </div>
                        ) : (
                          ' Create'
                        )}
                      </button>
                    </div>
                  </form>

                </div>
              </div>
              {/* lg:max-h-[830px] */}
              <div className="w-full lg:w-[50%] h-[50%] md:h-full">
                <img src={`${process.env.REACT_APP_API_BASE_URL}/public/assets/job%20image.png`} alt="job create" className='w-full h-full rounded-tr-lg rounded-br-lg object-cover' />
              </div>
            </div>
          </div>
        </main>



      </div>


    </div>
  )
}
export default CreateNewJob
